module.exports = __webpack_public_path__ + "static/media/YF48_0.7c49f42e.jpg";